import Locale from '@serv/Locale'

export function _resolvePatientJourneyListColumnOfType_icsDischargePlan(column, patientJourney, row) {
    if (!row[column.id] || !row[column.id].value) {
        return
    }

    column.cellText = Locale.getLanguageItemForModelEnumOrUndefined('periodType', row[column.id].value)
}
